import React, {
  ButtonHTMLAttributes,
  MouseEvent,
  memo,
  useCallback,
} from "react";
import type {
  HudNavItem,
} from "widgets/hud/model/routes.ts";
import {ButtonContainer} from "widgets/profile/ui/styles.ts";
import {useResize} from "../../../../app/lib/hooks/useResize.ts";
import {ChevronRightIcon} from "shared/ui/icons/chevronRight.tsx";

type BaseProps = {
  item: HudNavItem;
  isMobileMenu?: boolean;
  noCollapse?: boolean;
} & Pick<React.HTMLAttributes<HTMLElement>, "aria-label" | "aria-current" | "role" | "title">;

export type RawButtonProps = {isActive: boolean}
  & BaseProps
  & Partial<ButtonHTMLAttributes<HTMLButtonElement>>;

const RawButton = (props: RawButtonProps) => {
  const { item, onClick, isMobileMenu, isActive, ...rest } = props;
  
  const iconFill = isActive ? (item as any).iconActiveFill : (item as any).iconFill;
  
  const {isScreenMd} = useResize()
  
  const IconComp = item.icon;

  const btnRest = rest as Partial<ButtonHTMLAttributes<HTMLButtonElement>>;
  
  const handleClick = useCallback((e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick?.(e);
  }, [onClick]);
  
  return (
    <ButtonContainer
      $active={isActive}
      $isMobileMenu={isMobileMenu}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={handleClick}
      {...btnRest}
    >
      <IconComp fill={iconFill} />
      {item.label}
      {!isScreenMd && (<ChevronRightIcon />)}
    </ButtonContainer>
  );
};

export const ProfileButton = memo(RawButton);